import { Flex, H3, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { ScrollLayout } from "../../components/ScrollLayout"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import TextsForm from "./TextsForm"
import { Config } from "../../types"
import { useConfig, useConfigPartialUpdate } from "../../hooks/customization"

export default function TextsConfig() {
  const { data } = useConfig()

  useBreadcrumbs([{ label: "Testi" }])
  const updateTexts = useConfigPartialUpdate()

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H3>Testi</H3>
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={data ? data[0] : ({} as Config)}
            onSubmit={(values: Config) => {
              return updateTexts.mutateAsync({
                ...values,
              } as Config)
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <TextsForm />
                </Container>
                <BottomFormFixed url="/testi/testi" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
